/* unplugin-vue-components disabled */import script from "./paymethodList.vue?vue&type=script&setup=true&lang=js"
export * from "./paymethodList.vue?vue&type=script&setup=true&lang=js"

import "./paymethodList.vue?vue&type=style&index=0&id=1d3382bc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d3382bc"]])

export default __exports__